export default "__VITE_ASSET__DH1V2oKW__"